import { OverrideEntityType, } from '@wix/ambassador-forms-v4-form/types';
export function asRequired(value) {
    if (typeof asOptional(value) !== 'undefined') {
        return value;
    }
    throw new Error('Value is null | undefined');
}
export function isCondition(data) {
    return !!(data === null || data === void 0 ? void 0 : data.fact) && !!(data === null || data === void 0 ? void 0 : data.operator);
}
export function getRulesOrConditions(data) {
    return (data === null || data === void 0 ? void 0 : data.and) || (data === null || data === void 0 ? void 0 : data.or) || [];
}
export function asOptional(value) {
    return value == null ? undefined : value;
}
export function valueIsMissing(value) {
    return (typeof asOptional(value) === 'undefined' ||
        (typeof value === 'string' && value === ''));
}
export function lessThan(given, expected, orEqual = false) {
    return orEqual ? given <= expected : given < expected;
}
export function greaterThan(given, expected, orEqual = false) {
    return orEqual ? given >= expected : given > expected;
}
export function between(given, lowerBound, upperBound) {
    return greaterThan(given, lowerBound) && lessThan(given, upperBound);
}
export function asUtcDate(value) {
    try {
        const date = new Date(value);
        if (isNaN(date.getTime())) {
            return null;
        }
        return date;
    }
    catch (_) {
        return null;
    }
}
export function getNumberValuesToCompare(...values) {
    return values.map((value) => {
        if (typeof value === 'string') {
            return getDateUtcTimestamp(value);
        }
        if (typeof value === 'number') {
            return value;
        }
        return null;
    });
}
function getDateUtcTimestamp(givenValue) {
    const givenDate = asUtcDate(givenValue);
    return givenDate ? givenDate.getTime() : null;
}
export function isObject(givenValue) {
    return (typeof givenValue === 'object' &&
        !Array.isArray(givenValue) &&
        givenValue !== null);
}
export const isArrayOfNumbers = (value) => {
    return value.every((item) => typeof item === 'number');
};
export function isValueEmpty(givenValue) {
    return givenValue === undefined || givenValue === null || givenValue === '';
}
function isValidCondition(rule, fields = []) {
    if (rule === undefined) {
        return true;
    }
    const rulesOrConditions = getRulesOrConditions(rule);
    if (!rulesOrConditions.length) {
        return false;
    }
    return rulesOrConditions.every((conditionOrRule) => {
        if (isCondition(conditionOrRule)) {
            return fields === null || fields === void 0 ? void 0 : fields.some((field) => field.id === conditionOrRule.fact);
        }
        return isValidCondition(conditionOrRule, fields);
    });
}
export function isFormRuleValid(formRule, formSchema) {
    var _a;
    if (!formRule || !((_a = formRule === null || formRule === void 0 ? void 0 : formRule.overrides) === null || _a === void 0 ? void 0 : _a.length) || !formSchema) {
        return false;
    }
    const { fields, nestedForms } = formSchema;
    const conditionValid = isValidCondition(formRule.condition, fields);
    const overrideValid = formRule === null || formRule === void 0 ? void 0 : formRule.overrides.some((override) => {
        if (override.entityType === OverrideEntityType.FORM) {
            return (formSchema.id === override.entityId ||
                (nestedForms === null || nestedForms === void 0 ? void 0 : nestedForms.some((nestedForm) => { var _a; return ((_a = nestedForm.form) === null || _a === void 0 ? void 0 : _a.id) === override.entityId; })));
        }
        return fields === null || fields === void 0 ? void 0 : fields.some((field) => field.id === override.entityId);
    });
    return conditionValid && overrideValid;
}
//# sourceMappingURL=utils.js.map